<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
        </p>
        <p>
            <strong>Notice: Validation of debt Account: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}</strong>
        </p>
        <p class="letter-content">
            Please be advised this is not a refusal to pay, but a notice that your claim is disputed, and validation is requested in
            accordance with the Fair Debt Collections Practices Act, 15 USC 1692g.
        </p>
        <p class="letter-content">
            This is NOT a request for <strong>“verification”</strong> or proof of my mailing address, but a request for
            <strong>VALIDATION</strong> made pursuant to the above-named Title and
            Section. I respectfully request your offices provide me with competent evidence that I have any
            legal obligation to pay you.
        </p>
        <p class="letter-content">
            I am informing you now that if your office has reported invalidated information to any of the 3 major credit bureaus
            <strong>(Equifax, Experian or TransUnion)</strong> this action may constitute fraud under federal and state law. Due to this fact, if any
            negative marks appear on my credit reports as a result of your actions, I will not hesitate in bringing legal action
            against you and your client for violation of the Fair Credit Reporting Act, violations of the Fair Debt Collection
            Practices Act, and defamation of character.
        </p>
        <p class="letter-content">
            If your offices provide me with the documentation listed in the following declaration,
            I will require at least 30 days to investigate this information, during which time all
            collection activity must cease and desist. Also, during this validation period, if any action is
            taken which could be considered detrimental to any of my credit reports, I will consult with my
            legal counsel for a suit. This includes any listing of any information to a credit reporting
            repository that could be inaccurate or invalidated.
        </p>
        <p class="letter-content">
            If your office fails to respond to this validation request within 30 days from the date of your
            receipt, all references to this account must be deleted and completely removed from my credit
            file, and a copy of such deletion request shall be sent to me immediately
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }}
        </p>
    </div>  
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>
